import React, { Component } from "react";
import {
    View,
    ScrollView,
    Dimensions,
    TouchableOpacity,
    Image,
    Linking,
} from "react-native";
import { WHITE } from "react-native-material-color";
import Text from "../components/Text";
import * as Commons from "../utils/Commons";
import * as Styles from "../utils/Styles";
import * as AppStyles from "../utils/appStyles";
import Header from "../components/Header";

let width = Commons.getWidth();
let height = Dimensions.get("window").height;
let styles = {};
let isMobile = false;

const imgJdsLogo = require("../images/Header/JdsLogo.png");

class PrivacyPolicy extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isScrolled: false,
            hideScrollTopButton: true,
            initComplete: false,
        };
    }

    async componentDidMount() {
        setTimeout(() => {
            this.setState({ initComplete: true });
        }, 100);
    }

    renderHeader = () => {
        return (
            <View style={{
                flexDirection: 'row',
                alignItems: 'center',
                padding: 20,
                paddingHorizontal: isMobile ? 20 : 64,
                alignSelf: "stretch",
                justifyContent: "space-between",
                borderBottomWidth: 1,
                borderBottomColor: '#E8E8E8',
                backgroundColor: '#FFF',
            }}>
                <TouchableOpacity onPress={() => {
                    if (typeof window !== 'undefined') {
                        window.history.back();
                    } else if (this.props.navigation) {
                        this.props.navigation.goBack();
                    }
                }}>
                    <Image source={imgJdsLogo} style={{
                        width: 35.063,
                        height: 37,
                        resizeMode: "contain",
                    }} />
                </TouchableOpacity>
                <Text style={[AppStyles.LabelTextStyles, { color: Styles.appColor1, fontSize: 14 }]}>
                    Privacy Policy
                </Text>
            </View>
        );
    };

    renderSectionTitle = (text) => (
        <Text style={{
            fontFamily: Styles.fontFamily1,
            fontSize: isMobile ? 18 : 20,
            color: '#1F4E79',
            fontWeight: '700',
            marginTop: 32,
            marginBottom: 8,
        }}>
            {text}
        </Text>
    );

    renderSubTitle = (text) => (
        <Text style={{
            fontFamily: Styles.fontFamily1,
            fontSize: isMobile ? 15 : 16,
            color: '#1F4E79',
            fontWeight: '600',
            marginTop: 20,
            marginBottom: 6,
        }}>
            {text}
        </Text>
    );

    renderBody = (text) => (
        <Text style={{
            fontFamily: Styles.fontFamily1,
            fontSize: isMobile ? 13 : 14,
            color: '#2D2D2D',
            lineHeight: 22,
            marginBottom: 8,
        }}>
            {text}
        </Text>
    );

    renderBullet = (text) => (
        <View style={{ flexDirection: 'row', marginBottom: 4, paddingLeft: 8 }}>
            <Text style={{ color: '#2D2D2D', fontSize: 13, marginRight: 6 }}>{'\u2022'}</Text>
            <Text style={{
                fontFamily: Styles.fontFamily1,
                fontSize: isMobile ? 13 : 14,
                color: '#2D2D2D',
                lineHeight: 22,
                flex: 1,
            }}>
                {text}
            </Text>
        </View>
    );

    renderTableRow = (col1, col2, col3, isHeader = false) => {
        const cellStyle = {
            fontFamily: Styles.fontFamily1,
            fontSize: isMobile ? 11 : 13,
            color: isHeader ? '#FFF' : '#2D2D2D',
            lineHeight: 18,
            flexWrap: 'wrap',
        };
        const bgColor = isHeader ? '#1F4E79' : '#FFF';
        return (
            <View style={{
                flexDirection: 'row',
                borderBottomWidth: 1,
                borderColor: '#D7D7D7',
                backgroundColor: bgColor,
            }}>
                <View style={{ flex: col3 ? 1 : 1.5, padding: 8, borderRightWidth: 1, borderColor: '#D7D7D7' }}>
                    <Text style={cellStyle}>{col1}</Text>
                </View>
                <View style={{ flex: col3 ? 2 : 2.5, padding: 8, borderRightWidth: col3 ? 1 : 0, borderColor: '#D7D7D7' }}>
                    <Text style={cellStyle}>{col2}</Text>
                </View>
                {col3 !== undefined && (
                    <View style={{ flex: 1.5, padding: 8 }}>
                        <Text style={cellStyle}>{col3}</Text>
                    </View>
                )}
            </View>
        );
    };

    renderTable2Row = (col1, col2, isHeader = false) => {
        const cellStyle = {
            fontFamily: Styles.fontFamily1,
            fontSize: isMobile ? 11 : 13,
            color: isHeader ? '#FFF' : '#2D2D2D',
            lineHeight: 18,
            flexWrap: 'wrap',
        };
        const bgColor = isHeader ? '#1F4E79' : '#FFF';
        return (
            <View style={{
                flexDirection: 'row',
                borderBottomWidth: 1,
                borderColor: '#D7D7D7',
                backgroundColor: bgColor,
            }}>
                <View style={{ flex: 1.2, padding: 8, borderRightWidth: 1, borderColor: '#D7D7D7' }}>
                    <Text style={cellStyle}>{col1}</Text>
                </View>
                <View style={{ flex: 2.8, padding: 8 }}>
                    <Text style={cellStyle}>{col2}</Text>
                </View>
            </View>
        );
    };

    renderContent = () => {
        const containerWidth = isMobile ? width - 40 : Math.min(width - 120, 860);
        return (
            <View style={{ width: containerWidth, alignSelf: 'center', paddingBottom: 60 }}>

                {/* Title */}
                <Text style={{
                    fontFamily: Styles.fontFamily1,
                    fontSize: isMobile ? 28 : 40,
                    color: '#1F4E79',
                    fontWeight: '700',
                    marginTop: 40,
                    marginBottom: 4,
                    textAlign: 'center',
                }}>
                    Privacy Policy
                </Text>
                <Text style={{
                    fontFamily: Styles.fontFamily1,
                    fontSize: isMobile ? 16 : 18,
                    color: '#2D2D2D',
                    fontWeight: '600',
                    textAlign: 'center',
                    marginBottom: 4,
                }}>
                    Jordan Drugstore Company
                </Text>
                <Text style={{
                    fontFamily: Styles.fontFamily1,
                    fontSize: 14,
                    color: '#5F5F5F',
                    textAlign: 'center',
                    marginBottom: 8,
                }}>
                    Website, Online Ordering Portal, and Mobile Application
                </Text>
                <Text style={{
                    fontFamily: Styles.fontFamily1,
                    fontSize: 13,
                    color: '#5F5F5F',
                    textAlign: 'center',
                    marginBottom: 32,
                }}>
                    Last Updated: June 2026
                </Text>

                {/* Divider */}
                <View style={{ height: 1, backgroundColor: '#E8E8E8', marginBottom: 16 }} />

                {/* Section 1 */}
                {this.renderSectionTitle("1. Introduction")}
                {this.renderBody("Jordan Drugstore Company (\"JDS\", \"we\", \"our\", or \"us\") respects your privacy and is committed to protecting the personal data we collect and process through our website, online ordering portal, and mobile application.")}
                {this.renderBody("This Privacy Policy explains how we collect, use, store, protect, disclose, and retain personal data. It also explains the rights available to individuals in relation to their personal data.")}
                {this.renderBody("This Privacy Policy applies to our public corporate website, our online ordering portal for registered pharmacy customers, our mobile application available on Android and iOS, and public forms available through our website, including career/CV submissions, complaint forms, and new business inquiry forms.")}
                {this.renderBody("Jordan Drugstore Company is committed to complying with applicable data protection laws, including Jordan's Personal Data Protection Law No. 24 of 2023 and, where applicable, the General Data Protection Regulation (GDPR).")}

                {/* Section 2 */}
                {this.renderSectionTitle("2. Who We Are")}
                {this.renderBody("Jordan Drugstore Company is a pharmaceutical and parapharmaceutical distribution company based in Jordan.")}
                {this.renderBody("For the purposes of applicable data protection laws, Jordan Drugstore Company is the data controller responsible for determining how and why personal data is collected and processed through our website, ordering portal, and mobile application.")}

                {/* Privacy Contact Details box */}
                <View style={{
                    backgroundColor: '#1F4E79',
                    borderRadius: 8,
                    padding: 16,
                    marginTop: 12,
                    marginBottom: 12,
                }}>
                    <Text style={{ color: '#FFF', fontFamily: Styles.fontFamily1, fontSize: 15, fontWeight: '700', marginBottom: 8 }}>
                        Privacy Contact Details
                    </Text>
                    <Text style={{ color: '#FFF', fontFamily: Styles.fontFamily1, fontSize: 14, marginBottom: 4 }}>
                        Department: Quality and Compliance Department
                    </Text>
                    <Text style={{ color: '#FFF', fontFamily: Styles.fontFamily1, fontSize: 14 }}>
                        Email:{' '}
                        <Text style={{ color: '#C69200', textDecorationLine: 'underline' }}
                            onPress={() => Linking.openURL('mailto:jds@jdsco.net')}>
                            jds@jdsco.net
                        </Text>
                    </Text>
                </View>

                {/* Section 3 */}
                {this.renderSectionTitle("3. Scope of This Privacy Policy")}
                {this.renderBody("This Privacy Policy applies to personal data collected through our digital platforms only.")}
                {this.renderBody("The public website is primarily an informational website about Jordan Drugstore Company. It also includes access to a secure portal for registered pharmacy customers who have entered into a contractual agreement with us.")}
                {this.renderBody("The online ordering portal and mobile application are intended only for registered pharmacy customers. They are not intended for use by the general public. Accounts are created by Jordan Drugstore Company as part of the customer onboarding and agreement process. Users cannot self-register.")}
                {this.renderBody("No payment processing is available through the website, portal, or mobile application.")}

                {/* Section 4 */}
                {this.renderSectionTitle("4. Personal Data We Collect")}
                {this.renderSubTitle("4.1 Data Collected Through Public Website Forms")}
                {this.renderBody("We may collect personal data through the following forms:")}

                {/* Forms table */}
                <View style={{ borderWidth: 1, borderColor: '#D7D7D7', borderRadius: 4, marginVertical: 8, overflow: 'hidden' }}>
                    {this.renderTableRow("Form", "Personal Data Collected", "Purpose", true)}
                    {this.renderTableRow(
                        "Career/CV Form",
                        "CV or resume file; name, phone number, email address, address, job title, experience, education, and other professional information where included; selected department or job category.",
                        "Recruitment and evaluation of current or future employment opportunities."
                    )}
                    {this.renderTableRow(
                        "Contact Us / Complaint Form",
                        "Name, phone number, email address, and complaint details.",
                        "Receiving, reviewing, responding to, and managing complaints."
                    )}
                    {this.renderTableRow(
                        "Contact Us / New Business Inquiry Form",
                        "Name, business or company name, contact information, and business-related information included in the inquiry.",
                        "Reviewing and responding to potential business opportunities."
                    )}
                </View>

                {this.renderBody("Please do not submit prescriptions, patient information, medical information, or sensitive personal data through the contact us form unless specifically requested by us through an official channel.")}

                {this.renderSubTitle("4.2 Data Collected Through the Ordering Portal and Mobile App")}
                {this.renderBody("The ordering portal and mobile application are available only to registered pharmacy users. For pharmacy users, we may collect and process:")}
                {this.renderBullet("registered mobile number;")}
                {this.renderBullet("account number;")}
                {this.renderBullet("signed agreement documents;")}
                {this.renderBullet("company or pharmacy information;")}
                {this.renderBullet("order details;")}
                {this.renderBullet("account-related information;")}
                {this.renderBullet("portal and app access information necessary to enable ordering functionality.")}
                {this.renderBody("Accounts are created by Jordan Drugstore Company as part of the contractual onboarding process. There is no public self-registration.")}

                {this.renderSubTitle("4.3 Uploaded Files")}
                {this.renderBody("We may collect uploaded files in limited cases, including CVs or resumes uploaded by job applicants and scanned signed agreements uploaded during pharmacy onboarding. We do not collect prescriptions, patient files, uploaded invoices, licenses, or payment card documents through the website or app.")}

                {this.renderSubTitle("4.4 Mobile App Permissions and Technical Data")}
                {this.renderBody("Our mobile application may request access to your device camera. Camera access is used only for barcode scanning functionality.")}
                {this.renderBody("The app does not request location permission or storage permission.")}
                {this.renderBody("The mobile application may collect device tokens for the purpose of sending push notifications. These device tokens may be processed through Firebase/Google for push notification delivery.")}
                {this.renderBody("We do not collect device ID or advertising ID for advertising purposes.")}

                {this.renderSubTitle("4.5 Cookies and Server Logs")}
                {this.renderBody("Our website and portal use session cookies only. Session cookies are necessary to enable secure login and basic portal functionality.")}
                {this.renderBody("We do not currently use analytics cookies, marketing cookies, preference cookies, Google Analytics, Google Tag Manager, Meta Pixel, Hotjar, Microsoft Clarity, cross-page tracking, retargeting, or advertising tracking.")}
                {this.renderBody("Server logs may be processed for technical and security purposes and are retained only as necessary for order submission and system functionality.")}

                {/* Section 5 */}
                {this.renderSectionTitle("5. Data We Do Not Collect")}
                {this.renderBody("Through the website, ordering portal, and mobile application, we do not knowingly collect:")}
                {this.renderBullet("payment or card information;")}
                {this.renderBullet("health or medical data;")}
                {this.renderBullet("prescriptions;")}
                {this.renderBullet("patient information;")}
                {this.renderBullet("insurance information;")}
                {this.renderBullet("children's data;")}
                {this.renderBullet("advertising IDs;")}
                {this.renderBullet("location data;")}
                {this.renderBullet("data for retargeting or behavioral advertising.")}
                {this.renderBody("If you submit sensitive personal data to us without being requested to do so, we may delete, restrict, or disregard such information where appropriate.")}

                {/* Section 6 */}
                {this.renderSectionTitle("6. Purposes of Processing Personal Data")}
                {this.renderBody("We process personal data for the following purposes:")}
                {this.renderBullet("to operate and maintain our website, portal, and mobile application;")}
                {this.renderBullet("to allow registered pharmacy users to access their accounts and place orders;")}
                {this.renderBullet("to process and fulfill pharmacy orders through our internal systems;")}
                {this.renderBullet("to manage contractual relationships with registered pharmacy customers;")}
                {this.renderBullet("to receive and assess CVs and job applications;")}
                {this.renderBullet("to respond to complaints submitted through our public form;")}
                {this.renderBullet("to review and respond to new business inquiries;")}
                {this.renderBullet("to communicate with users when necessary;")}
                {this.renderBullet("to maintain system security and prevent unauthorized access;")}
                {this.renderBullet("to send operational push notifications through the mobile application;")}
                {this.renderBullet("to comply with legal, regulatory, accounting, contractual, or audit obligations;")}
                {this.renderBullet("to protect our rights, systems, business operations, and users.")}
                {this.renderBody("We do not use personal data collected through the website, portal, or app for advertising retargeting, behavioral profiling, or sale to third parties.")}

                {/* Section 7 */}
                {this.renderSectionTitle("7. Legal Basis for Processing")}
                {this.renderBody("We process personal data only where we have a lawful basis to do so under applicable data protection laws.")}

                <View style={{ borderWidth: 1, borderColor: '#D7D7D7', borderRadius: 4, marginVertical: 8, overflow: 'hidden' }}>
                    {this.renderTable2Row("Legal Basis", "How It Applies", true)}
                    {this.renderTable2Row("Contractual necessity", "We process pharmacy account, login, agreement, and order data to perform our contractual relationship with registered pharmacy customers.")}
                    {this.renderTable2Row("Consent", "We may rely on consent where users voluntarily submit information through public forms, upload CVs, submit inquiries, or enable push notifications.")}
                    {this.renderTable2Row("Legitimate business interests", "We may process certain data to operate and secure our website, portal, and app; respond to inquiries; maintain business records; improve internal processes; and protect our systems and business operations, provided such interests do not override the rights and freedoms of individuals.")}
                    {this.renderTable2Row("Legal or regulatory obligations", "We may process and retain certain information where required for legal, regulatory, accounting, contractual, tax, audit, or compliance purposes.")}
                </View>

                {this.renderBody("Where consent is required, users may be asked to acknowledge this Privacy Policy or provide consent before submitting forms or enabling specific features.")}

                {/* Section 8 */}
                {this.renderSectionTitle("8. Consent")}
                {this.renderBody("Where we rely on consent, we aim to ensure that consent is requested in a clear and understandable manner and is specific to the relevant purpose.")}
                {this.renderBody("By submitting a public form, uploading a CV, submitting a complaint, or submitting a business inquiry, you acknowledge that the information you provide will be processed for the relevant purpose described in this Privacy Policy.")}
                {this.renderBody("Where a consent checkbox is provided, you should only submit the form if you agree to the processing described in this Privacy Policy.")}
                {this.renderBody("You may withdraw your consent at any time by contacting us at jds@jdsco.net. Withdrawal of consent does not affect the lawfulness of processing carried out before the withdrawal.")}

                {/* Section 9 */}
                {this.renderSectionTitle("9. Pharmacy Portal and Mobile App Users")}
                {this.renderBody("The ordering portal and mobile application are provided only to registered pharmacy customers who have entered into a contractual relationship with Jordan Drugstore Company.")}
                {this.renderBody("Pharmacy users access the portal or app using account information agreed upon during onboarding. Order data submitted through the website or app is integrated with Jordan Drugstore Company's internal Oracle E-Business Suite system for order processing and fulfillment.")}
                {this.renderBody("Orders cannot be paid for through the website or mobile application. No payment card data is collected or processed through these platforms.")}

                {/* Section 10 */}
                {this.renderSectionTitle("10. Third-Party Services and Processors")}
                {this.renderBody("Jordan Drugstore Company operates its main systems internally and primarily stores data on company-managed servers in Jordan.")}
                {this.renderBody("We do not currently use third-party analytics tools, advertising pixels, email marketing platforms, payment gateways, live chat tools, map providers, or CAPTCHA tools through the website, portal, or app.")}
                {this.renderBody("The mobile application uses Firebase/Google for push notification functionality only. Device tokens may be shared with Firebase/Google for the purpose of delivering push notifications. Google's applicable privacy and security terms may apply to this processing.")}
                {this.renderBody("We do not sell personal data.")}
                {this.renderBody("We do not share personal data with marketing agencies, advertising platforms, or third parties for retargeting or behavioral advertising.")}

                {/* Section 11 */}
                {this.renderSectionTitle("11. Data Storage and Data Residency")}
                {this.renderBody("Primary data is stored on Jordan Drugstore Company's on-premise servers in Jordan.")}
                {this.renderBody("Order and account data is processed through Jordan Drugstore Company's internal Oracle E-Business Suite system and is hosted on-premise in Jordan.")}
                {this.renderBody("Access to data is restricted to authorized personnel only, based on business need and role-based access permissions.")}
                {this.renderBody("Some backups may be maintained for business continuity and security purposes. Backup access is restricted to authorized JDS IT personnel.")}
                {this.renderBody("Where any service provider or technical tool processes data outside Jordan, we will take reasonable steps to ensure that such processing is carried out in accordance with applicable data protection requirements.")}

                {/* Section 12 */}
                {this.renderSectionTitle("12. International Data Transfers")}
                {this.renderBody("Jordan Drugstore Company's core systems and primary data storage are located in Jordan.")}
                {this.renderBody("We do not generally transfer personal data outside Jordan through the website, portal, or ordering system.")}
                {this.renderBody("However, where mobile app push notifications are enabled, device tokens may be processed by Firebase/Google for the purpose of delivering push notifications. To the extent such processing involves data transfer outside Jordan, we rely on appropriate safeguards and applicable legal mechanisms to protect the data.")}
                {this.renderBody("Where the GDPR applies, we will take appropriate steps to ensure that international transfers are carried out in accordance with GDPR requirements.")}

                {/* Section 13 */}
                {this.renderSectionTitle("13. Data Retention")}
                {this.renderBody("We retain personal data only for as long as necessary for the purpose for which it was collected, unless a longer retention period is required or permitted by law, contract, accounting rules, audit requirements, regulatory obligations, or legitimate business needs.")}
                {this.renderBody("Our current retention approach includes:")}

                <View style={{ borderWidth: 1, borderColor: '#D7D7D7', borderRadius: 4, marginVertical: 8, overflow: 'hidden' }}>
                    {this.renderTable2Row("Data Type", "Retention Period", true)}
                    {this.renderTable2Row("CVs of unsuccessful applicants", "12 months, then deleted.")}
                    {this.renderTable2Row("CVs of hired applicants", "Transferred to the HR employee file and deleted from the portal.")}
                    {this.renderTable2Row("Order and account records", "Retained as part of the core business database for contractual, operational, accounting, audit, and legal purposes.")}
                    {this.renderTable2Row("Contact, complaint, and new business inquiry emails", "Retained in internal email systems for as long as necessary for business, legal, administrative, or follow-up purposes.")}
                    {this.renderTable2Row("Analytics records", "Not applicable, as we do not currently use analytics tools.")}
                    {this.renderTable2Row("Server logs", "Retained only as necessary for order submission and system functionality.")}
                </View>

                {this.renderBody("We may refuse or limit deletion requests where retention is required for legal, contractual, accounting, audit, compliance, or legitimate business purposes.")}

                {/* Section 14 */}
                {this.renderSectionTitle("14. Data Security")}
                {this.renderBody("We take appropriate technical and organizational measures to protect personal data against unauthorized access, disclosure, alteration, loss, misuse, or destruction.")}
                {this.renderBody("Our security measures may include:")}
                {this.renderBullet("SSL/HTTPS protection for the website and app;")}
                {this.renderBullet("password protection;")}
                {this.renderBullet("hashed passwords;")}
                {this.renderBullet("two-factor authentication for authorized access;")}
                {this.renderBullet("restricted access to authorized personnel;")}
                {this.renderBullet("daily backups;")}
                {this.renderBullet("restricted backup access;")}
                {this.renderBullet("backend admin-user logging;")}
                {this.renderBullet("internal IT controls;")}
                {this.renderBullet("Security Operations Center monitoring and incident notification;")}
                {this.renderBullet("ISO 27001-aligned incident response procedures.")}
                {this.renderBody("While we take reasonable measures to protect personal data, no digital system can be guaranteed to be completely secure. Users should also take appropriate steps to protect their login information and avoid sharing access credentials with unauthorized persons.")}

                {/* Section 15 */}
                {this.renderSectionTitle("15. Data Breaches and Security Incidents")}
                {this.renderBody("If a personal data breach or security incident occurs, we will take appropriate steps to investigate, contain, and address the incident.")}
                {this.renderBody("Where required by applicable law, we will notify affected individuals and/or the competent authority of a data breach that affects the security, confidentiality, or integrity of personal data.")}

                {/* Section 16 */}
                {this.renderSectionTitle("16. Your Rights")}
                {this.renderBody("Subject to applicable law and any legal limitations, you may have the right to:")}
                {this.renderBullet("request access to your personal data;")}
                {this.renderBullet("request correction or updating of inaccurate or incomplete data;")}
                {this.renderBullet("request deletion of your personal data;")}
                {this.renderBullet("withdraw consent where processing is based on consent;")}
                {this.renderBullet("request restriction or limitation of processing;")}
                {this.renderBullet("object to certain processing activities;")}
                {this.renderBullet("request a copy of your personal data, where applicable;")}
                {this.renderBullet("object to profiling or automated decision-making, where applicable;")}
                {this.renderBullet("be informed of a data breach affecting your personal data, where required by law;")}
                {this.renderBullet("lodge a complaint with the competent data protection authority, where applicable.")}
                {this.renderBody("To exercise your rights, please contact us at jds@jdsco.net.")}
                {this.renderBody("Privacy requests are handled by the Quality and Compliance Department. Requests may be submitted by email or phone. We may need to verify your identity before responding to certain requests.")}
                {this.renderBody("We will respond to requests in accordance with applicable legal requirements.")}

                {/* Section 17 */}
                {this.renderSectionTitle("17. Marketing Communications")}
                {this.renderBody("We do not currently send newsletters or marketing campaigns through the website or mobile application.")}
                {this.renderBody("We do not upload customer lists to advertising platforms.")}
                {this.renderBody("We do not use personal data collected through the website, portal, or app for retargeting or behavioral advertising.")}
                {this.renderBody("If we introduce marketing communications in the future, we will provide appropriate notice and, where required, obtain consent. Users will also be given a way to unsubscribe or opt out.")}

                {/* Section 18 */}
                {this.renderSectionTitle("18. Cookies")}
                {this.renderBody("We use session cookies only. These cookies are necessary for the secure operation of the website, portal, and login session.")}
                {this.renderBody("We do not currently use cookies for analytics, advertising, retargeting, or user behavior tracking.")}
                {this.renderBody("You may configure your browser to block or delete cookies; however, disabling session cookies may affect your ability to access or use certain portal features.")}

                {/* Section 19 */}
                {this.renderSectionTitle("19. Mobile Push Notifications")}
                {this.renderBody("The mobile application may send push notifications related to operational app or ordering functionality.")}
                {this.renderBody("To enable push notifications, device tokens may be processed through Firebase/Google. You may manage or disable push notifications through your device settings.")}
                {this.renderBody("Disabling push notifications may affect your ability to receive certain app alerts, but it will not prevent you from using the main ordering functionality where otherwise available.")}

                {/* Section 20 */}
                {this.renderSectionTitle("20. Children's Privacy")}
                {this.renderBody("Our website, ordering portal, and mobile application are not directed to children.")}
                {this.renderBody("We do not knowingly collect children's personal data through the website, portal, or mobile application. If we become aware that children's data has been submitted to us, we may delete it where appropriate.")}

                {/* Section 21 */}
                {this.renderSectionTitle("21. Sensitive Personal Data")}
                {this.renderBody("We do not intentionally collect sensitive personal data through the website, portal, or mobile application, including health data, patient data, prescriptions, insurance details, payment card data, biometric data, or children's data.")}
                {this.renderBody("Users should not submit sensitive personal data through public forms unless specifically requested by Jordan Drugstore Company through an official and secure channel.")}

                {/* Section 22 */}
                {this.renderSectionTitle("22. Automated Decision-Making and Profiling")}
                {this.renderBody("We do not use personal data collected through the website, portal, or mobile application for automated decision-making, behavioral profiling, retargeting, or advertising purposes.")}

                {/* Section 23 */}
                {this.renderSectionTitle("23. Links to Third-Party Websites")}
                {this.renderBody("Our website or app may contain links to third-party websites or services. We are not responsible for the privacy practices, content, or security of third-party websites.")}
                {this.renderBody("Users should review the privacy policies of any third-party websites or services they access.")}

                {/* Section 24 */}
                {this.renderSectionTitle("24. Updates to This Privacy Policy")}
                {this.renderBody("We may update this Privacy Policy from time to time to reflect changes in our practices, systems, services, or legal requirements.")}
                {this.renderBody("The updated version will be published on our website and/or made available through the mobile application. The \"Last Updated\" date at the top of this Privacy Policy indicates when it was last revised.")}

                {/* Section 25 */}
                {this.renderSectionTitle("25. Contact Us")}
                {this.renderBody("For any privacy-related questions, requests, or complaints, please contact:")}

                <View style={{
                    backgroundColor: '#1F4E79',
                    borderRadius: 8,
                    padding: 16,
                    marginTop: 12,
                    marginBottom: 12,
                }}>
                    <Text style={{ color: '#FFF', fontFamily: Styles.fontFamily1, fontSize: 14, marginBottom: 4 }}>
                        <Text style={{ fontWeight: '700' }}>Company: </Text>Jordan Drugstore Company
                    </Text>
                    <Text style={{ color: '#FFF', fontFamily: Styles.fontFamily1, fontSize: 14, marginBottom: 4 }}>
                        <Text style={{ fontWeight: '700' }}>Privacy Contact: </Text>Quality and Compliance Department
                    </Text>
                    <Text style={{ color: '#FFF', fontFamily: Styles.fontFamily1, fontSize: 14 }}>
                        <Text style={{ fontWeight: '700' }}>Email: </Text>
                        <Text style={{ color: '#C69200', textDecorationLine: 'underline' }}
                            onPress={() => Linking.openURL('mailto:jds@jdsco.net')}>
                            jds@jdsco.net
                        </Text>
                    </Text>
                </View>

                {this.renderBody("We will review and respond to privacy requests in accordance with applicable data protection laws.")}

                {/* Footer */}
                <View style={{ height: 1, backgroundColor: '#E8E8E8', marginTop: 40, marginBottom: 16 }} />
                <Text style={{
                    fontFamily: Styles.fontFamily1,
                    fontSize: 12,
                    color: '#5F5F5F',
                    textAlign: 'center',
                    marginBottom: 8,
                }}>
                    Jordan Drugstore Company | Privacy Policy | Last Updated: June 2026
                </Text>
            </View>
        );
    };

    render() {
        if (!this.state.initComplete) return null;

        Commons.resizeHandle(window, this, () => {
            width = this.width;
            height = this.height;
            this.setState({ width, height });
        });

        width = Dimensions.get("window").width - 2;
        height = Dimensions.get("window").height;
        isMobile = Commons.isMobile();

        return (
            <View style={{ flex: 1, backgroundColor: '#FFF' }}>
                {this.renderHeader()}
                <ScrollView
                    showsVerticalScrollIndicator={false}
                    contentContainerStyle={{ flexGrow: 1 }}
                >
                    {this.renderContent()}
                </ScrollView>
            </View>
        );
    }
}

export default PrivacyPolicy;
